import * as Api from '@ViewModels';

const GENERAL_EXAMPLE =
	'Example: Thank each client for their business this year, mention the last thing we helped them with, and invite ' +
	'them to reply if anything has changed.';

// Only industries with a goal worth showing; the rest fall back to the general one rather than a stretched fit.
const EXAMPLES: Partial<Record<Api.Industry, string>> = {
	[Api.Industry.Accounting]:
		'Example: Remind each client of the documents we still need for this year’s return, based on what they sent ' +
		'last year, and offer a time to go over them.',
	[Api.Industry.Architecture]:
		'Example: Check in with past clients whose project finished over a year ago, recall what we designed for them, ' +
		'and ask whether they have anything new in mind.',
	[Api.Industry.AutoRepair]:
		'Example: Remind each client that their vehicle is approaching its next scheduled service, referencing the ' +
		'vehicle on file and what was done last visit.',
	[Api.Industry.Chiropractic]:
		'Example: Invite patients who have not been in for three months to book a follow-up, mentioning what we last ' +
		'treated them for.',
	[Api.Industry.Consulting]:
		'Example: Follow up with past clients on the engagement we finished for them, ask how the changes are holding ' +
		'up, and offer a short review call.',
	[Api.Industry.Dental]:
		'Example: Remind patients who are due for a cleaning to book their next visit, mentioning when they were last ' +
		'in.',
	[Api.Industry.Engineering]:
		'Example: Check in with past clients about the project we delivered, ask how it is performing, and mention ' +
		'that we can help with the next phase.',
	[Api.Industry.Financial]:
		'Example: Invite each client to a mid-year review, mentioning the goals they shared at our last meeting and ' +
		'anything that has changed since.',
	[Api.Industry.Health]:
		'Example: Remind patients who are due for their annual check-up to book it, mentioning when they were last seen.',
	[Api.Industry.HomeMaintenance]:
		'Example: Remind each homeowner that their system is due for its seasonal service, referencing the work we did ' +
		'last time.',
	[Api.Industry.Insurance]:
		'Example: Remind each client that their policy renews next month, mention the coverage they have with us, and ' +
		'offer a quick review before it does.',
	[Api.Industry.Legal]:
		'Example: Check in with past clients whose estate plan is more than three years old and suggest a review, ' +
		'mentioning when we last updated it.',
	[Api.Industry.Mortgage]:
		'Example: Let past borrowers know rates have moved since they closed, mention their loan with us, and offer to ' +
		'see whether refinancing makes sense.',
	[Api.Industry.NonProfit]:
		'Example: Thank each donor for their support this year, mention what their gift helped with, and invite them ' +
		'to our next event.',
	[Api.Industry.RealEstate]:
		'Example: Send past buyers a note on their home’s anniversary, mention how prices have moved in their ' +
		'neighborhood, and offer a free valuation.',
	[Api.Industry.Recruiting]:
		'Example: Check in with candidates we placed a year ago, ask how the role is going, and mention that we are ' +
		'here when they are ready for the next step.',
};

/** The goal box's example, written for the account's industry so it reads like a campaign they would actually send. */
export const getGoalExample = (industry?: Api.Industry | null) => (industry && EXAMPLES[industry]) || GENERAL_EXAMPLE;
